module.exports = __webpack_public_path__ + "static/media/claims.95923dc4.mp4";